import React, { useState, useEffect } from "react";
import PlacesAutocomplete, { geocodeByAddress } from "react-places-autocomplete";

const PlaceComponent = ({ value, onChange, field, label, error }) => {
  const [address, setAddress] = useState(value || "");

  const handleSelect = async (selectedAddress) => {
    try {
      // Geocode to get full address components including zip code
      const results = await geocodeByAddress(selectedAddress);
      if (results && results.length > 0) {
        const place = results[0];
        const components = place.address_components;

        // Extract address parts
        const streetNumber = components.find(c => c.types.includes("street_number"))?.long_name || "";
        const route = components.find(c => c.types.includes("route"))?.long_name || "";
        const subpremise = components.find(c => c.types.includes("subpremise"))?.long_name || "";
        const city = components.find(c => c.types.includes("locality"))?.long_name || "";
        const state = components.find(c => c.types.includes("administrative_area_level_1"))?.short_name || "";
        const zip = components.find(c => c.types.includes("postal_code"))?.long_name || "";

        // Build full address with zip code
        let streetPart = streetNumber && route ? `${streetNumber} ${route}` : route || streetNumber;
        if (subpremise) {
          streetPart += ` ${subpremise}`;
        }

        let fullAddress = streetPart;
        if (city) fullAddress += `, ${city}`;
        if (state) fullAddress += `, ${state}`;
        if (zip) fullAddress += ` ${zip}`;

        setAddress(fullAddress);
        onChange(field, fullAddress);
      } else {
        // Fallback to the selected address string
        setAddress(selectedAddress);
        onChange(field, selectedAddress);
      }
    } catch (err) {
      console.error("Error geocoding address:", err);
      // Fallback to the selected address string
      setAddress(selectedAddress);
      onChange(field, selectedAddress);
    }
  };

  useEffect(() => {
    const interval = setInterval(() => {
      const input = document.querySelector(".pac-target-input");
      if (input) {
        input.setAttribute("placeholder", "");
  
        const observer = new MutationObserver(() => {
          input.setAttribute("placeholder", "");
        });
        observer.observe(input, {
          attributes: true,
          attributeFilter: ["placeholder"],
        });
  
        clearInterval(interval);
      }
    }, 100);
  
    return () => clearInterval(interval);
  }, []);
  

  return (
    <div className="place-wrapper">
      <label className="form-label">{label}<span className="text-danger">*</span></label>
      <PlacesAutocomplete
        value={address}
        onChange={setAddress}
        onSelect={handleSelect}
        debounce={300}
      >
        {({ getInputProps, suggestions, getSuggestionItemProps, loading }) => (
          <div className="autocomplete-root">
            <input
              {...getInputProps({
                placeholder: "",
                className: "form-control",
              })}
            />

            {(loading || suggestions.length > 0) && (
                <div className="autocomplete-dropdown">
                {loading && <div className="suggestion-item">Loading...</div>}

                {suggestions.map((suggestion) => {
                    const className = suggestion.active
                    ? "suggestion-item active"
                    : "suggestion-item";
                    return (
                    <div
                        {...getSuggestionItemProps(suggestion, {
                        className,
                        })}
                        key={suggestion.placeId}
                    >
                        {suggestion.description}
                    </div>
                    );
                })}
                </div>
             )}     
            {error && <div className="text-danger mt-1">{error}</div>}
          </div>
        )}
      </PlacesAutocomplete>
    </div>
  );
};

export default PlaceComponent;